import React, { ForwardedRef, forwardRef } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SearchIcon from '@mui/icons-material/Search';

import { StyleButton } from './style';

import { InteractionType } from '@interfaces/learning';

export type InteractiveButtonProps = {
  interactionType: InteractionType;
  title: string;
  onClick?: React.MouseEventHandler;
};

const InteractiveButton = (
  { interactionType, title, onClick }: InteractiveButtonProps,
  ref: ForwardedRef<HTMLButtonElement>,
) => {
  const getIcon = () => {
    switch (interactionType) {
      case InteractionType.ARTICLE:
        return <SearchIcon />;

      default:
        return <HelpOutlineIcon />;
    }
  };

  return (
    <StyleButton
      className="vjs-interactive-button"
      ref={ref}
      variant="contained"
      color="inherit"
      startIcon={getIcon()}
      onClick={onClick}
    >
      {title}
    </StyleButton>
  );
};

export default forwardRef<HTMLButtonElement, InteractiveButtonProps>(InteractiveButton);
